import { Button, Fab, IconButton, Typography, Box } from "@mui/material";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { useState } from "react";

interface Props {
    sendToNames: string[]
    sendToPhones: string[]
    friendly: boolean
}

export default function WazzapNotifyButton({ sendToNames, sendToPhones, friendly }: Props) {
    const [showText, setShowText] = useState(false);

    const handleFabClick = (ind: number) => {
        if (sendToPhones.length < ind + 1) {
            alert("Missing number");
            return;
        }
        if (showText) {
            const url = `https://wa.me/${sendToPhones[ind]}?text=${encodeURIComponent(
                `${friendly ? "Ey" : "Älskling!"}!!! Nytt i listan ${process.env.REACT_APP_REDIRECT_URL}`
            )}`;
            window.open(url, "_blank");

        }
        setShowText(!showText);
    }

    if (sendToNames.length < 1 || sendToPhones.length < 1) return (<></>)

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, alignItems: 'flex-start' }}>
            {showText && sendToNames.length > 1 && (
                sendToNames.slice(1, undefined).map((person, index) => (
                    <Fab
                        key={`whatsappSend_${index}`}
                        color="primary"
                        aria-label="add"
                        size="small"
                        style={{ backgroundColor: '#ffffff', gap: 4 }}
                        onClick={() => handleFabClick(index)}
                        variant={!showText ? 'circular' : 'extended'}
                    >
                        <Box
                            onClick={(e) => {
                                e.stopPropagation();
                                setShowText(!showText);
                            }}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                // paddingLeft:'0.5px',
                                cursor: 'pointer',
                                color: "#94c494",
                                '&:hover': {
                                    opacity: 0.8
                                }
                            }}
                        >
                            <WhatsAppIcon />
                        </Box>
                        <Typography style={{ fontSize: '14px', paddingRight: "4px", color: "#94c494" }}>
                            Låt {person} veta
                        </Typography>
                    </Fab>
                ))
            )}
            <Fab
                key={`whatsappSend_0`}
                color="primary"
                aria-label="add"
                size="small"
                style={{ backgroundColor: '#ffffff', gap: 4 }}
                onClick={() => handleFabClick(0)}
                variant={!showText ? 'circular' : 'extended'}
            >
                <Box
                    onClick={(e) => {
                        e.stopPropagation();
                        setShowText(!showText);
                    }}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        // paddingLeft:'0.5px',
                        cursor: 'pointer',
                        color: "#94c494",
                        '&:hover': {
                            opacity: 0.8
                        }
                    }}
                >
                    <WhatsAppIcon />
                </Box>
                {showText && (
                    <Typography style={{ fontSize: '14px', paddingRight: "4px", color: "#94c494" }}>
                        Låt {sendToNames[0]} veta
                        {/* Låt Klas veta */}
                    </Typography>
                )}
            </Fab>
        </div>
    )
}